export const DEFAULT_BATCH_SIZE = 20

export const INTERVAL_OPTIONS = [
    { label: 'Day', value: 'Day' },
    { label: 'Month', value: 'Month' },
    { label: 'Custom', value: 'custom' },
    { label: 'Monday', value: 'Monday' },
    { label: 'Tuesday', value: 'Tuesday' },
    { label: 'Wednesday', value: 'Wednesday' },
    { label: 'Thursday', value: 'Thursday' },
    { label: 'Friday', value: 'Friday' },
    { label: 'Saturday', value: 'Saturday' },
    { label: 'Sunday', value: 'Sunday' },
] as const;

export const CURRENCY_OPTIONS = [
    { label: 'INR', value: 'INR' },
    { label: 'USD', value: 'USD' },
] as const;
